import { FC } from "react";

type Props = {
  percentage: number;
};

export const ProgressBar: FC<Props> = ({ percentage }) => {
  const color = percentage === 100 ? "bg-herb-600" : "bg-delicate-600";
  return (
    <div className="overflow-hidden rounded-full bg-gray-200 w-full">
      <div
        style={{ width: `${percentage}%` }}
        className={["h-1.5 sm:h-2 rounded-full", color].join(" ")}
      />
    </div>
  );
};
